import React, { Component } from "react";
import PropTypes from "prop-types";
import IconButton from "material-ui/IconButton";
import ActionSave from "material-ui/svg-icons/content/save";
import ActionCopy from "material-ui/svg-icons/content/content-copy";
import ActionPaste from "material-ui/svg-icons/content/content-paste";
import Toggle from "material-ui/Toggle";
import Paper from "material-ui/Paper";
import { Box } from "rebass";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { BlockCounter, ProductListInput } from "./components";
import { DivHeaderActions, DivTitle } from "./styled";
import { RestApiProductList } from "../../../../restClient";
class ProductListView extends Component {
  constructor(props) {
    super(props);
    const { showPrice, containerPadding, list } = props.data.values;
    this.state = {
      isEditMode: false,
      expanded: true,
      containerPadding: containerPadding,
      list: list,
      showPrice: showPrice
    };
  }
  getProductList = () => {
    const { list } = this.state;
    let newValue = [];
    if (Array.isArray(list)) {
      newValue = list;
    }
    let params = newValue.join();

    const url = "/products?collections=" + params;
    RestApiProductList(url)
      .then(response => {
        return response.json();
      })
      .then(items => {
        if (items && !items.messages) {
          let newItems = [];
          for (var i = 0; i < items.length; ++i) {
            for (var j = 0; j < items[i].products.length; ++j)
              newItems.push(items[i].products[j]);
          }
          const { id } = this.props;
          const productlist = "ProductListView" + id;
          localStorage.setItem(productlist, JSON.stringify(newItems));
          localStorage.setItem(
            `ProductListViewID${id}`,
            JSON.stringify(params)
          );
        }
      })
      .catch(e => {
        console.error(e);
      });
  };
  onClickCopy = () => {
    let newData = this.props.data;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.list = this.state.list;
    newData.values.showPrice = this.state.showPrice;
    localStorage.setItem("ProductListView", JSON.stringify(newData.values));
  };
  onClickPaste = () => {
    const IconContent = JSON.parse(localStorage.getItem("ProductListView"));
    if (IconContent) {
      const { list, containerPadding, showPrice } = IconContent;
      this.setState({
        list,
        containerPadding,
        showPrice
      });
    }
  };
  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };
  onClickSave = () => {
    let newData = this.props.data;
    newData.values.containerPadding = this.state.containerPadding;
    newData.values.list = this.state.list;
    newData.values.showPrice = this.state.showPrice;

    this.getProductList();
    this.props.onUpdateData(newData);
  };

  onUpdatePadding = padding => {
    this.setState({ containerPadding: padding });
  };

  onUpdateProduct = values => {
    this.setState({ list: values });
  };
  onTogglePrice = (e, v) => {
    this.setState({ showPrice: v });
  };
  render() {
    return (
      <div style={{ width: "100%" }}>
        <div style={styles.paperCard}>
          <Card
            expanded={this.state.expanded}
            onExpandChange={this.handleExpandChange}
          >
            <CardHeader
              title="General"
              subtitle="Content Product List"
              actAsExpander={true}
              showExpandableButton={true}
              style={styles.headerCard}
            />
            <CardText
              expandable={true}
              style={{ overflowY: "scroll", height: 500 }}
            >
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Collections</DivTitle>
                <ProductListInput
                  values={this.state.list}
                  onChangeList={product => this.onUpdateProduct(product)}
                  typePage={this.props.typePage}
                  marketerId={this.props.marketerId}
                />
              </Paper>
              <Paper style={styles.paperText} zDepth={1}>
                <DivTitle>Container Padding</DivTitle>
                <BlockCounter
                  containerPadding={this.state.containerPadding}
                  onUpdatePadding={containerPadding =>
                    this.onUpdatePadding(containerPadding)
                  }
                />
                <Box w={[1]} py={[1]}>
                  <Toggle
                    label="Show Price"
                    style={{ marginBottom: 10 }}
                    toggled={this.state.showPrice}
                    onToggle={(e, v) => this.onTogglePrice(e, v)}
                  />
                </Box>
              </Paper>
            </CardText>
          </Card>
        </div>
        <DivHeaderActions>
          <IconButton
            onClick={this.onClickCopy}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionCopy />
          </IconButton>
          <IconButton
            onClick={this.onClickPaste}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionPaste />
          </IconButton>
          <IconButton
            onClick={this.onClickSave}
            iconStyle={{ color: "#FFFFFF" }}
          >
            <ActionSave />
          </IconButton>
        </DivHeaderActions>
      </div>
    );
  }
}

const styles = {
  paper: {
    margin: 10,
    padding: 10
  },
  headerCard: {
    display: "flex",
    textAlign: "left"
  },
  paperCard: {
    margin: 10
  },
  paperText: {
    padding: 10,
    marginBottom: 10
  },
  customWidth: {
    width: 150
  },
  block: {
    maxWidth: 250
  },
  radioButton: {
    width: 60
  },
  radioGroup: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    flex: "1 auto"
  }
};

ProductListView.propTypes = {
  data: PropTypes.object,
  id: PropTypes.string,
  onUpdateData: PropTypes.func.isRequired,
  typePage: PropTypes.string,
  marketerId: PropTypes.string
};

ProductListView.defaultProps = {
  data: {},
  id: "",
  typePage: "",
  marketerId: "0"
};
export default ProductListView;



// WEBPACK FOOTER //
// ./src/editor/layout/addons/props/ProductListView.js